import { Box, Typography } from "@mui/material";
import { tableTextStyles } from "./cellUtils";

export type NameCellProps = {
  primary: string;
  secondary?: string;
  primaryFallback?: string;
  secondaryFallback?: string;
  maxWidth?: number;
};

export function NameCell({
  primary,
  secondary,
  primaryFallback = "Unknown",
  secondaryFallback = "",
  maxWidth,
}: NameCellProps) {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        height: "100%",
        py: 1,
        overflow: "hidden",
      }}
    >
      <Box sx={{ overflow: "hidden", maxWidth }}>
        <Typography
          sx={{
            ...tableTextStyles,
            fontWeight: 500,
            color: "text.primary",
          }}
        >
          {primary || primaryFallback}
        </Typography>
        {(secondary !== undefined || secondaryFallback) && (
          <Typography
            sx={{
              ...tableTextStyles,
              fontSize: "12px",
              color: "text.secondary",
            }}
          >
            {secondary || secondaryFallback}
          </Typography>
        )}
      </Box>
    </Box>
  );
}
